import { InjectionToken } from '@angular/core';

export const STORAGE_PREFIX = new InjectionToken<string>('STORAGE_PREFIX');

export const STORAGE_KEYS = {
  EVENTS: 'events',
  ATTENDANCE: 'attendance',
  SETTINGS: 'settings',
  CONNECTION: 'connection',
  CURRENT_EVENT: 'current_event',
  TEST_MODE_OVERRIDES: 'test_mode_overrides',
  QR_TEMPLATE_LIBRARY: 'qr_template_library'
} as const; 